
<template>
   <div class="finanzasSIM">
      <div class="encabezado">
            <h6 class="mb-0">ALUMNO</h6>
      </div>
      <div v-for="(info, i) in users" :key="i" class="divisionLineas">
         <div data-toggle="collapse" :data-target="'#sim' + i" class="accordion-toggle cursorPointer">
            <vs-row>
               <vs-col sm="6" lg="1" class="text-center">
                  <i v-if="info.cargos.length" class="fas fa-sort-down" style="font-size: 1.4rem"></i>
               </vs-col>
               <vs-col sm="12" lg="11" class="d-flex justify-content-between">
                  <div>
                     <p class="mb-0"><strong>{{info.alumno}}</strong></p>
                     <p><small>MATRÍCULA: </small><strong>{{info.matricula}}</strong></p>
                  </div>
                  <div class="ml-3 text-center">
                     <p class="mb-0"><small>CICLOS ESCOLARES CON CARGOS</small></p>
                     <md-chip class="mb-1 fontMedium mini-chip col-blue"><strong> {{ info.cargos.length }} </strong></md-chip>
                  </div>
               </vs-col>
            </vs-row>
         </div>
         <div class="accordian-body collapse maginTabla" :id="'sim' + i"> 
               <div class="encabezado">
                  <h6 class="mb-0">CICLO ESCOLAR</h6>
               </div>
               <div v-for="(cargos, c) in info.cargos" :key="c" class="cargosGenerales">
                  <div data-toggle="collapse" :data-target="'#simCiclo' + i + c" class="accordion-toggle d-flex align-items-end cursorPointer">
                     <i v-if="cargos.info.length" class="fas fa-sort-down mr-2" style="font-size: 1.4rem"></i> <h6 class="mb-0">{{cargos.nombre}} </h6>
                  </div>
                  <div class="accordian-body collapse maginTabla" :id="'simCiclo' + i + c">
                     <div class="encabezado">
                        <h6 class="mb-0">CARGOS</h6>
                     </div>
                     <div v-for="(infoCargos, ic) in cargos.info" :key="ic" class="divisionLineas">
                        <vs-row  data-toggle="collapse" :data-target="'#simCargo' + i + c + ic" class="accordion-toggle d-flex align-items-end cursorPointer">
                           <vs-col sm="12" lg="3" class="d-flex align-items-center">
                              <div>
                                 <i v-if="infoCargos.abonos.length" class="fas fa-sort-down mr-2" style="font-size: 1.4rem"></i>
                              </div>
                              <div>
                                 <p class="mb-0"><small>CONCEPTO</small></p>
                                 <p class="mb-0"> <strong>{{infoCargos.concepto_cobro}}</strong></p>
                              </div>
                           </vs-col>
                           <vs-col sm="12" lg="3">
                              <p class="mb-0"><small>MONTO ANTES DE VENCIMIENTO</small></p>
                              <p class="mb-0"><strong>{{infoCargos.montoav | currency}}</strong></p>
                           </vs-col>
                           <vs-col sm="12" lg="3">
                              <p class="mb-0"><small>MONTO DESPUÉS DE VENCIMIENTO</small></p>
                              <p class="mb-0"><strong>{{infoCargos.montodv | currency}}</strong></p>
                           </vs-col>
                           <vs-col sm="12" lg="3">
                              <p class="mb-0"><small>FECHA DE VENCIMIENTO</small></p>
                              <p class="mb-0"><strong>{{infoCargos.fecha_vencimiento}}</strong></p>
                           </vs-col>
                        </vs-row>
                        <div  class="accordian-body collapse maginTabla" :id="'simCargo' + i + c + ic">
                           <div class="encabezado">
                                 <h6 class="mb-0">ABONOS</h6>
                           </div>
                           <div v-for="(abonos, ab) in infoCargos.abonos" :key="ab" class="cargosGenerales">
                              <div data-toggle="collapse" :data-target="'#simAbono' + i + ab" class="accordion-toggle d-flex justify-content-between maginTabla divisionLineas">
                                 <div>
                                    <p class="mb-0"><small>PAGO</small></p>
                                    <p>{{abonos.pago | currency}}</p>
                                 </div>
                                 <div>
                                    <p class="mb-0"><small>FECHA DE PAGO</small></p>
                                    <p>{{abonos.fecha_pago}}</p>
                                 </div>
                                 <div>
                                    <p class="mb-0"><small>FECHA DE OPERACIÓN</small></p>
                                    <p>{{abonos.fecha_op}}</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   props: [
      'users'
   ]
}
</script>


<style lang="scss" scoped >
@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
    @include text-colors ('blue', #2d8bf6, #c7e1ff ); 
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236) );
}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);  
    @include text-colors ('blue', #2d8bf6, #c7e1ff ); 
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236) );
}

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }


    .divisionLineas:not(:last-child){
        border-bottom: 1px solid #E5E7E9; 
    }
    .divisionLineas{
        padding: 2% 0;
    }
.finanzasSIM{
    .encabezado{
        border-radius: 14px 14px 0 0;
        background: #F4F7F8;
        padding: 10px 12px;
    }

    .cargosGenerales{
      border-bottom: 1px solid #E5E7E9;
      padding: 1rem;
    }
    .maginTabla{
      margin: 1rem 0 1rem 2.5rem;
    }
    .cursorPointer{
      cursor: pointer;
    }
}
</style>

<style>